<template>
  <v-menu offset-y data-cy="toolbar-menu">
    <template #activator="{ on, attrs }">
      <v-btn
        text
        tile
        class="text-subtitle-2"
        v-bind="attrs"
        v-on="on"
        data-cy="toolbar-menu-button"
      >
        {{ identificadorUsuario }}
        <v-icon class="pl-2" data-cy="toolbar-menu-icon">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>

    <v-list dense data-cy="toolbar-list">
      <slot name="toolbar-user-options" />
      <v-list-item
        link
        data-cy="toolbar-list-item-logout"
        @click="() => $store.dispatch('logout')"
      >
        <v-list-item-title data-cy="toolbar-list-item-logout-title">
          <v-icon
            small
            class="pr-2"
            color="error"
            data-cy="toolbar-list-item-logout-icon"
          >
            mdi-exit-to-app
          </v-icon>
          Sair
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  computed: {
    usuario() {
      return this.$store.getters.user;
    },

    identificadorUsuario() {
      return this.usuario?.identificador ?? '';
    }
  }
};
</script>
